// extracted by mini-css-extract-plugin
module.exports = {"marker":"MapMarker-module__marker___2pAq-","hover":"MapMarker-module__hover___3U4LD","markerLabel":"MapMarker-module__markerLabel___1zIzg"};